import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=6d7b2726&scoped=true&"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=6d7b2726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7b2726",
  null
  
)

export default component.exports